import React from 'react';

import FormGroup from 'reactstrap/lib/FormGroup';

import FormText from 'reactstrap/lib/FormText';

import FormFeedback from 'reactstrap/lib/FormFeedback';

import Label from 'reactstrap/lib/Label';

import AvForm from 'availity-reactstrap-validation/lib/AvForm';

import AvField from 'availity-reactstrap-validation/lib/AvField';

import AvInput from 'availity-reactstrap-validation/lib/AvInput';

import classNames from 'classnames';

import ModalFooter from 'reactstrap/lib/ModalFooter';

import DMAv from './DMAV';

import isString from 'lodash/isString';

import isArray from 'lodash/isArray';

class DMForm extends React.Component {
	/*

		label =  label for input
		inputType = text/radio/checkbox
		dataType = email/string/number
		feedback =
		formTextColor =
		formText =

	*/

	constructor(props) {
		super(props);

		this.state = {
			saving: false,
			checkboxesClickedForShowingIf: {},
			loaded: false,
		};

		this.multiInstant = {};
	}

	componentDidMount() {
		this.setState({
			loaded: true,
		});
	}

	handleInvalidSubmit = (e) => {
		if (this.props.form.invalidSubmit) {
			this.props.form.invalidSubmit(e);
		}
	};

	handleValidSubmit = (e, data) => {
		Object.keys(this.multiInstant).map((k) => {
			let v = this.multiInstant[k];

			let o = [];

			for (var i = 0; i < v; i++) {
				let kk = k + '_' + i;

				o.push(data[kk]);

				delete data[kk];
			}

			data[k] = o;
		});

		let submit = this.props.form.submit(data);

		if (submit) {
			if (!this.unmounted) {
				this.setState({
					saving: true,
				});
			}

			submit.then((failed) => {
				if (
					this.props.form.clearFormAfterSubmit &&
					!failed &&
					this.refs.formtty
				) {
					this.refs.formtty.reset();
				}

				if (!this.unmounted) {
					this.setState({
						saving: false,
					});
				}
			});
		}
	};

	componentWillUnmount() {
		this.unmounted = true;
	}

	checkValues(onChange, e, val) {
		if (onChange) {
			onChange(val);
		}

		this.forceUpdate();
	}

	showField(element) {
		if (!this.state.loaded) {
			return 0;
		}

		if (!element.showIf) {
			return 1;
		}

		let that = this;

		let value;

		if (isString(element.showIf)) {
			return this.showFieldIsString(element.showIf);
		}

		if (isArray(element.showIf)) {
			let ret = 1;

			element.showIf.map((field) => {
				if (isString(field)) {
					let show = that.showFieldIsString(field);

					ret = ret * show;
				}
			});

			return ret;
		}
	}

	showFieldIsString(field) {
		let value = this.AVFORM.getValue(field);

		if (value && value != 0) {
			return 1;
		}

		return 0;
	}

	multiAdd = (e, field) => {
		e.stopPropagation();

		this.multiInstant[field.name.replace(/_[0-9]*$/, '')]++;

		this.forceUpdate();
	};

	render() {
		let state = this.state;

		if (!state.loaded) {
			return null;
		}

		let form = this.props.form;

		let fields = form.fields;

		let button = form.button;

		let that = this;

		let model = {};

		let fields1 = [];

		{
			fields.map((field, key) => {
				if (field.inputType == 'checkbox') {
					model[field.name] = field.value;
				}

				if (!field.returnArray) {
					fields1.push(field);

					return;
				}

				if (!this.multiInstant[field.name]) {
					this.multiInstant[field.name] = 1;
				}

				let n = field.name;

				for (var i = 0; i < this.multiInstant[field.name]; i++) {
					let field1 = Object.assign({}, field);

					field1.name = n + '_' + i;

					fields1.push(field1);
				}
			});
		}

		return (
			<AvForm
				ref='formtty'
				onValidSubmit={this.handleValidSubmit}
				onInvalidSubmit={this.handleInvalidSubmit}
				model={model}
			>
				<DMAv
					ref={(avform) => {
						that.AVFORM = avform;
					}}
				></DMAv>

				{form.preText && <div className='row form-group'>{form.preText}</div>}

				{fields1.map((element, key) => {
					return (
						<FormGroup
							key={key}
							className={classNames('row', element.rowClassName)}
							style={{ display: that.showField(element) ? 'flex' : 'none' }}
						>
							{element.label && (
								<label
									className={classNames(
										form.labelsAboveFields || element.inputType == 'subtitle'
											? 'col-md-12'
											: 'col-md-4',
										'col-form-label',
										element.labelClassName,
										element.inputType == 'checkbox' ? 'col-6' : ''
									)}
								>
									{that.showField(element) &&
									(element.inputType == 'subtitle' ||
										element.inputType == 'plainText') ? (
										element.inputType == 'subtitle' ? (
											<h3>{element.label}</h3>
										) : (
											<span>{element.label}</span>
										)
									) : (
										element.label
									)}
									{!!element.returnArray && (
										<i
											className='fas fa-plus ml-1'
											onClick={(e) => this.multiAdd(e, element)}
										/>
									)}
								</label>
							)}

							<div
								style={{
									marginLeft: element.inputType == 'checkbox' ? '-10px' : '',
									paddingLeft: element.inputType == 'checkbox' ? '45px' : '',
								}}
								className={classNames(
									form.labelsAboveFields || !element.label
										? 'col-md-12'
										: 'col-md-8',
									element.inputType == 'checkbox' ? 'col-6' : ''
								)}
							>
								<div className={classNames(element.elementClassName)}>
									{(function () {
										switch (element.inputType) {
											case 'select':
												return (
													<AvField
														name={element.name}
														required={element.required}
														disabled={that.state.saving || element.disabled}
														ref={element.name}
														type={element.inputType}
														errorMessage={element.errorMessage}
														helpMessage={element.helpMessage}
														value={element.value}
														placeholder={element.placeHolder}
														validate={element.validate}
														onChange={that.checkValues.bind(
															that,
															element.onChange
														)}
													>
														{element.inputType == 'select' &&
															element.values.map((val, k) => {
																return (
																	<option value={val.id} key={k}>
																		{val.name}
																	</option>
																);
															})}
													</AvField>
												);
												break;

											case 'checkbox':
												return (
													<Label className='col-form-label'>
														<AvInput
															type='checkbox'
															disabled={that.state.saving || element.disabled}
															name={element.name}
															trueValue={element.trueValue}
															falseValue={element.falseValue}
															onChange={that.checkValues.bind(
																that,
																element.onChange
															)}
														/>
														&nbsp;
													</Label>
												);

												break;

											case 'subtitle':
												return '';

												break;

											case 'plainText':
												return (
													<div className='col-form-label'>{element.value}</div>
												);

												break;

											case 'customElement':
												return (
													<div className='row form-group'>
														<label className='col-md-4 col-form-label'>
															{element.name}
														</label>
														<div className='col-md-8'>
															<div className=''>
																<div className='form-group'>
																	{element.value}
																</div>
															</div>
														</div>
													</div>
												);

												break;

											default:
												return (
													<AvField
														name={element.name}
														required={element.required}
														disabled={that.state.saving || element.disabled}
														ref={element.name}
														type={element.inputType}
														errorMessage={element.errorMessage}
														helpMessage={element.helpMessage}
														value={element.value}
														placeholder={element.placeHolder}
														validate={element.validate}
														maxLength={element.maxLength}
														rows={element.rows}
														onChange={that.checkValues.bind(
															that,
															element.onChange
														)}
													/>
												);

												break;
										}
									})()}
								</div>
							</div>

							{element.inputType == 'checkbox' && (
								<div className='col-md-12'>
									<small className='form-text'>{element.helpMessage}</small>
								</div>
							)}
						</FormGroup>
					);
				})}

				{form.postText && <div className='row form-group'>{form.postText}</div>}

				{!button.keepButtonsOutOfFooter && form.inModal ? (
					<ModalFooter>
						{form.showCancelButton && (
							<button
								disabled={this.state.saving || button.disabled}
								type='button'
								className='btn btn-default float-left'
								onClick={form.closeButton}
							>
								Cancel
							</button>
						)}
						<button
							disabled={this.state.saving || button.disabled}
							className={classNames('btn', button.class)}
						>
							{button.text}
						</button>
					</ModalFooter>
				) : (
					<div className='row form-group'>
						{form.labelsAboveFields ? (
							''
						) : (
							<label className={classNames('col-md-4')}></label>
						)}

						<div
							className={classNames(
								form.labelsAboveFields
									? 'col-md-12'
									: 'text-center text-md-left col-md-8',
								button.position ? 'text-' + button.position : ''
							)}
						>
							<button
								disabled={this.state.saving || button.disabled}
								className={classNames('btn', button.class)}
							>
								{button.text}
							</button>
						</div>
					</div>
				)}
			</AvForm>
		);
	}
}

export default DMForm;
